import React from "react";
import styled from "styled-components";
import MyProjects from "../../components/Projects";




const Projects = () => {
    return (
        <Container>
        <MyProjects/>
        </Container>
    );
};

const Container = styled.div`

`;

export default Projects






